import React from "react";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import topBanner from "../../../Assets/Images/Image/Portfolio/bg.webp";

const PortfolioTop = ({ css }) => {
  return (
    <Fragment>
      <section className={"bg-[#EFF3FF] mb-[100px]"}>
        <div className="max-w-[1700px] px-5 max-sm:px-10 mx-auto ">
          <h2 className="pt-[100px] text-center text-[#000000] text-[25px] max-sm:text-[50px] max-lg:text-[70px] font-fira font-bold uppercase">
            Our Recent projects
          </h2>
          <p className=" px-3 max-sm:px-0 max-sm:w-[432px] mx-auto uppercase mb-6 font-bold text-center text-[#838383]">
            Get deep idea about our work by exploring our last activity
          </p>
          <div className="flex flex-col max-sm:flex-row justify-center items-center gap-5 pb-10">
            <Link to="/contact">
              <button
                style={{ borderRadius: "0", boxShadow: "none" }}
                className={css.btn}
              >
                {" "}
                More Views
                <i className="fa-solid fa-arrow-right ml-2"></i>
              </button>
            </Link>
            <Link to="/contact">
              <button
                style={{ borderRadius: "0", boxShadow: "none" }}
                className="custom_button mx-auto flex justify-center items-center "
              >
                {" "}
                Contact Us
                <i className="fa-solid fa-arrow-right ml-2"></i>
              </button>
            </Link>
          </div>

          <img src={topBanner} alt="IT Ghar" />
        </div>
      </section>
    </Fragment>
  );
};

export default PortfolioTop;
